import React, { Component } from "react";
import AdminSidebar from "../sidebar/admin_sidebar";
import AdminHeader from "../header/admin_header";
import config from "../../config/config.json";
import axios from "axios";
import { sweetAlert } from "../../utils/UniversalFunction";
import "./control.css";
import { authenticationService } from "../../_services/authentication";
const currentUser = authenticationService.currentUserValue;

export default class EditCompanyPolicy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      items: [],
      loading: false,
      policies: [],
      id:"",
      type: "",
      question: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
  }

  handleSubmit(event) {
    let uri = window.location.pathname.split("/");
    let id = uri[3];
    console.log("id", id);
    event.preventDefault();
    this.setState({ submitted: true });
    const { type, question } = this.state;
    const headers = {
      Authorization: `Bearer ${currentUser.data.token}`,
      Accept: "application/json",
    };
    axios
      .post(
        config.API_URL + `updatePolicy/${id}`,
        {
          type: type,
          question:question
        },
        { headers }
      )
      .then((response) => {
        sweetAlert("success", response.data.message);
      })
      .catch(function (error) {
        if (error.response) {
          sweetAlert("error", error.response.data.message);
        }
      });
  }

  componentDidMount() {
    let uri = window.location.pathname.split("/");
    let id = uri[3];
    const headers = {
      Authorization: `Bearer ${currentUser.data.token}`,
      Accept: "application/json",
    };
    fetch(config.API_URL + `getAllPolicyByID/${id}`, {headers})
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded2: true,
            type: result.policies[0].type,
            question: result.policies[0].question
          });
        },

        (error2) => {
          this.setState({
            isLoaded2: true,
            error2,
          });
        }
      );
  }

  render() {
    const { type, question } = this.state;
    return (
      <div>
        <AdminSidebar dataFromParent={this.props.location.pathname} />
        <AdminHeader />
        <div className="main_wrapper">
          <div className="inner_wraapper">
            <div className="container-fluid">
              <section className="d_text">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="col-sm-12">
                        <div className="color_div_on framwork_2">
                          <div className="business_detail">
                            <div className="">
                              <div className="saved_cards">
                                <form name="form" onSubmit={this.handleSubmit}>
                                  <div className="business_detail">
                                    <div className="heading">
                                      <h4>Update Policy</h4>
                                    </div>
                                    <hr className="line"></hr>

                                    <div className="row">
                                      <div className="col-lg-12 col-xs-12">
                                        <div className="form-group">
                                          <label
                                            htmlFor="title"
                                            className="mb-2"
                                          >
                                            Policy Category*
                                          </label>
                                          <input
                                            type="text"
                                            disabled
                                            className="form-control py-3"
                                            id="type"
                                            placeholder="Enter Policy Category"
                                            name="type"
                                            value={type}
                                            onChange={this.handleChange}
                                          />
                                        </div>
                                      </div>
                                      <div className="form-group">
                                        <label
                                          htmlFor="question"
                                          className="mb-2"
                                        >
                                          Policy Name*
                                        </label>
                                        <textarea
                                          type="text"
                                          className="form-control"
                                          id="question"
                                          placeholder="Enter Policy Name"
                                          name="question"
                                          value={question}
                                          onChange={this.handleChange}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="global_link mx-0 my-3">
                                    <button
                                      type="submit"
                                      className="page_width page_save"
                                    >
                                      UPDATE NOW
                                    </button>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
